module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.certificateType === 'finance') ? _c('div', {
    staticClass: "score"
  }, [_c('h2', {
    staticClass: "score__title"
  }, [_vm._v("Информация по сертификату")]), _c('div', {
    staticClass: "score__info"
  }, [_c('ScoreItem', {
    attrs: {
      "title": "Всего"
    }
  }, [_vm._v(_vm._s(_vm.certificateAmountTotal))]), _c('ScoreItem', {
    attrs: {
      "title": "Списано"
    }
  }, [_vm._v(_vm._s(_vm.certificateAmountWithdraw))]), _c('ScoreItem', {
    attrs: {
      "title": "Доступно",
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.certificateAmountCurrent))]), _c('ScoreItem', {
    attrs: {
      "title": "Заблокировано",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.certificateAmountOnHold))])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6148394d","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/certificate/components/score/Score.vue
// module id = 323d51f09ecbafd4faf2
// module chunks = 9